var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearchV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7965 21.7083L17.084 16.9958M19.6302 10.875C19.6302 15.6615 15.75 19.5417 10.9635 19.5417C6.17707 19.5417 2.29688 15.6615 2.29688 10.875C2.29688 6.08857 6.17707 2.20837 10.9635 2.20837C15.75 2.20837 19.6302 6.08857 19.6302 10.875Z",
    stroke: "#000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchV2);
export default __webpack_public_path__ + "static/media/icon-searchV2.c8dca05fab9504983349b53df2352de2.svg";
export { ForwardRef as ReactComponent };